exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".jUWp7_P5YwwVGN{align-items:center;background-color:rgba(9,30,66,.13);border-radius:18px;color:rgba(9,30,66,.54);display:flex;font-size:10px;height:16px;justify-content:center;min-width:24px}.u-CEbh41VF_ZZ5.jUWp7_P5YwwVGN,button:active .jUWp7_P5YwwVGN,button:hover .jUWp7_P5YwwVGN{color:rgba(9,30,66,.71)}._18H1ApTggJYL9m{margin-top:4px}._1WVRi-oPvfjD88:first-of-type ._18H1ApTggJYL9m{margin-top:0}", ""]);

// exports
exports.locals = {
	"countContainer": "jUWp7_P5YwwVGN",
	"selected": "u-CEbh41VF_ZZ5",
	"cardDueTabButton": "_18H1ApTggJYL9m",
	"cardDueContainer": "_1WVRi-oPvfjD88"
};